var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("publicHeader"),
      _c("el-main", [
        _c("div", { staticClass: "privacy" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("footer_menus.privacy")))]),
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "株式会社コノル（以下「当社」といいます。）は、当社が提供する商品又は各サービス（以下「本サービス」といいます。）を利用者の皆様（以下「お客様」といいます。）に安心してご利用いただくため、最低限の個人情報をご提供いただいております。また当社ではご提供いただいた個人情報の保護につきまして、プライバシーポリシー（以下「本ポリシー」といいます。）に則り、細心の注意をもって厳重に管理しております。"
            ),
          ]),
          _c("h2", [_vm._v("1. 個人情報とは")]),
          _c("p", [
            _vm._v(
              "本ポリシーにおいて、個人情報とは、当社が提供する本サービスを利用するためのID、ニックネーム、メールアドレス、携帯メールアドレス、名前、住所等、特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む。）を指します。"
            ),
          ]),
          _c("h2", [_vm._v("2. 情報の管理について")]),
          _c("p", [
            _vm._v(
              "当社は、プライバシー尊重の観点から、個人情報は保護すべき重要な情報であると認識し、お客様の個人情報を収集した際には厳重に管理致します。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "当社は、個人情報に対する不正アクセス・改ざん・漏洩・紛失・破壊などに関し予防措置を講ずるとともに、万一このような事態が発生した際にはお客様へのご迷惑を最小限にとどめるよう速やかに対応致します。"
            ),
          ]),
          _c("h2", [_vm._v("3. 情報の収集について")]),
          _c("p", [
            _vm._v(
              "当社は、お客様に対して、本サービスをご利用の際、会員登録をいただいた際、当社運営サイトでの商品ご購入の際など、必要に応じてお客様のお名前、ご住所、メールアドレス、その他の個人情報のご提供をアンケート形式でお願いする場合があります。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "所定の利用目的に対し提供がない場合には、本サービスを利用できないなどの不都合が生じる場合があることを予めご了承ください。"
            ),
          ]),
          _c("h2", [_vm._v("4. 個人情報の使用目的")]),
          _c("ol", { staticClass: "list" }, [
            _c("li", [
              _vm._v(
                "（１）当社は、ご本人より書面やWebサイトを通じて直接個人情報を取得する場合で、当社の事業における個人情報の主な利用目的には、次のようなものがあります。"
              ),
              _c("ol", [
                _c("li", [
                  _vm._v("（イ）お客様に関する個人情報の利用目的"),
                  _c("ol", { staticClass: "list" }, [
                    _c("li", [
                      _vm._v(
                        "① お客様への商品・サービス・サポートの提案、販売または提供するため"
                      ),
                    ]),
                    _c("li", [
                      _vm._v(
                        "② お客様への商品に関する利用状況の通知や商品の不具合に関する情報の提供など本サービスの提供のため"
                      ),
                    ]),
                    _c("li", [
                      _vm._v(
                        "③ お客様に有益と思われる当社の他のサービス又は当社の業務提携先の商品・サービス・イベント・セミナー等の案内を、お客様がアクセスした当社のウェブその他会員登録済みの他のお客様の端末装置上に表示し、又は電子メールもしくは郵便等により送付するため（なお、お客様は、当社に届け出ることにより、これらの利用を中止させたり、再開させたりすることができます。）"
                      ),
                    ]),
                    _c("li", [
                      _vm._v("④ お問合せまたはご依頼に対する対応のため"),
                    ]),
                    _c("li", [
                      _vm._v(
                        "⑤ 本サービスにおける会員登録済みのお客様の個人情報の属性の集計、分析を行い、個人が識別・特定できないように加工したもの（以下「統計資料」といいます。）を作成し、新規サービスの開発等の業務の遂行のために利用するため"
                      ),
                    ]),
                    _c("li", [
                      _vm._v("⑥ キャンペーンの実施およびプレゼントの送付"),
                    ]),
                  ]),
                ]),
                _c("li", [
                  _vm._v("（ロ）お取引先様に関する個人情報の利用目的"),
                  _c("ol", { staticClass: "list" }, [
                    _c("li", [
                      _vm._v(
                        "① お取引先様との商談・打合せの実施、および連絡など"
                      ),
                    ]),
                    _c("li", [
                      _vm._v("② お取引ご担当者様への情報提供、および連絡など"),
                    ]),
                    _c("li", [_vm._v("③ お取引先様から委託された業務の実施")]),
                    _c("li", [_vm._v("④ お取引先様との支払及び請求のため")]),
                  ]),
                ]),
              ]),
            ]),
            _c("li", [
              _vm._v(
                "（２）個人情報を書面やWeb以外の方法で直接ご本人から取得する場合や公開情報や第三者を経由して取得する場合の利用目的は、取得の状況から利用目的が明らかである場合および法令により利用目的の通知・公表が不要とされる場合を除き、次のとおりあらかじめ公表します。"
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "（イ）本サービス利用者から提供を受けた個人情報の利用目的"
                  ),
                  _c("ol", { staticClass: "list" }, [
                    _c("li", [_vm._v("① 本サービスの運営及び管理のため")]),
                    _c("li", [
                      _vm._v(
                        "② 本サービスに関連する情報提供・サービスの充実及び広告表示の最適化"
                      ),
                    ]),
                    _c("li", [
                      _vm._v(
                        "③ 当社又は第三者の取扱う各種商品、サービス等の情報の広告・案内・提供・維持管理"
                      ),
                    ]),
                    _c("li", [
                      _vm._v(
                        "④ メールマガジンの配信その他当社からのお知らせメール"
                      ),
                    ]),
                    _c("li", [_vm._v("⑤ 印刷物送付")]),
                    _c("li", [_vm._v("⑥ アンケートその他の調査")]),
                    _c("li", [
                      _vm._v("⑦ その他本サービスの遂行に関連・付随する業務"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("li", [
              _vm._v(
                "（３）利用目的の達成に必要な範囲を超えて個人情報を利用する場合は、原則として、利用目的等について再度ご本人に同意を得るものとします。ただし、次のいずれかに該当する場合はこの限りではありません。"
              ),
              _c("ol", [
                _c("li", [_vm._v("① 法令に基づく場合")]),
                _c("li", [
                  _vm._v(
                    "② 人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき"
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "③ 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき"
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "④ 国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき"
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("p", [
            _vm._v(
              "(注) お客様は個々の個人情報を本サービス利用のために提供するかどうかを自ら決めることが出来ます。ただし所定の利用目的に対し提供がない場合には、本サービスを利用できない場合があることをご了承ください。"
            ),
          ]),
          _c("h2", [_vm._v("5. 個人情報の第三者への提供について")]),
          _c("p", [
            _vm._v(
              "弊社は、お客様より取得させていただいた個人情報を適切に管理し、次の場合を除き、第三者に提供することはありません。"
            ),
          ]),
          _c("ol", { staticClass: "list" }, [
            _c("li", [_vm._v("① ご本人の同意がある場合")]),
            _c("li", [
              _vm._v(
                "② 法人その他の団体の役員および株主に関する公開情報で、あらかじめ第三者提供等についてご本人に通知又は公表しているとき"
              ),
            ]),
            _c("li", [
              _vm._v(
                "③ 特定した利用目的の達成に必要な範囲内において、個人情報の取り扱いの全部又は一部を委託するとき"
              ),
            ]),
            _c("li", [
              _vm._v(
                "④ 合併その他の事由による事業の承継に伴って個人情報を提供する場合であって、承継前の利用目的の範囲内で当該個人情報を取り扱うとき"
              ),
            ]),
            _c("li", [
              _vm._v(
                "⑤ 法令等に定める手順を経て個人情報を特定の者との間で共同利用する場合"
              ),
            ]),
            _c("li", [_vm._v("⑥ 法令に基づく場合")]),
            _c("li", [
              _vm._v(
                "⑦ 人の生命、身体又は財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき"
              ),
            ]),
            _c("li", [
              _vm._v(
                "⑧ 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき"
              ),
            ]),
            _c("li", [
              _vm._v(
                "⑨ 国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき"
              ),
            ]),
          ]),
          _c("h2", [_vm._v("6. 個人情報の共同利用について")]),
          _c("p", [
            _vm._v(
              "弊社は、特定の事業者と共同して事業活動を行うとき、必要となるお客様の個人情報を当該事業者と共同利用する場合がありますが、この場合は、あらかじめご本人に利用目的等を通知又は公表いたします。また、安全管理が図られるよう、個人情報の共同利用に関する契約の締結や適切な管理を行います。"
            ),
          ]),
          _c("h2", [_vm._v("7. 個人情報の預託について")]),
          _c("p", [
            _vm._v("以下に該当する場合を除き、預託をすることはありません。"),
          ]),
          _c("p", [
            _vm._v(
              "個人情報に関する機密保持契約を締結している業務委託会社に対し、お客様に明示した利用目的の達成に必要な範囲で個人情報の取り扱いを委託する場合"
            ),
          ]),
          _c("h2", [_vm._v("8. ダイレクトメールについて")]),
          _c("p", [
            _vm._v(
              "個人情報としてご登録いただいた宛先（メールアドレス・ご住所）に対して、事前に許可を得た方に限り、お客様に有益と思われる情報を当社あるいは提供先企業などからメール送信、または郵送させていただくことがあります。許可をあとから取り消すことも可能です。"
            ),
          ]),
          _c("h2", [_vm._v("9. 個人情報の変更・取消について")]),
          _c("p", [
            _vm._v(
              "弊社では、個人情報の保護に関する法律に基づき、開示対象個人情報のご本人又はその代理人からの利用目的の通知、開示、訂正・追加又は削除、利用停止・消去又は第三者提供の停止 (以下、「開示等の求め」といいます。) の求めに対応させていただきます。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "お客様自身で、個人情報の変更を希望される場合は、所定のフォームより変更手続を行ってください。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "お客様が開示等の求めを希望される場合は、以下に記載する「個人情報に関するお問い合わせ先」までご連絡ください。この場合、お客様ご自身であることが当社にて確認できた場合に限り、対応させていただきます。"
            ),
          ]),
          _c("h2", [_vm._v("10. 18歳未満の方へのお願い")]),
          _c("p", [
            _vm._v(
              "18歳未満の方が当社の各種サービスを利用し個人情報を入力する際は、必ず保護者の方の同意を得て行うようお願い致します。所定の個人情報の提供がない場合、または虚偽の個人情報であった場合には、特定のサービスが提供できないことがありますのでご了承ください。"
            ),
          ]),
          _c("h2", [_vm._v("11. 個人情報の保持期間と利用期間について")]),
          _c("p", [
            _vm._v(
              "当社で収集した個人情報は、お客様が当社のサービスを受ける間、当社で保管・管理致します。お客様は、当社で保管・管理している自らの個人情報について開示を求めることができます。ただし当社では第三者への情報漏洩を防止するため、お客様自身であることが当社で確認できた場合に限り、速やかに当該情報をお客様に開示致します。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "お客様が会員資格を失った場合、収集された個人情報はすべて削除されます。また、お客様から削除・訂正のご要望があった場合には、お客様ご自身であることが当社にて確認できた場合に限り、速やかに当該情報を削除・訂正致します。"
            ),
          ]),
          _c("h2", [_vm._v("12. クッキーについて")]),
          _c("p", [
            _vm._v(
              "クッキーとは、お客様の情報をブラウザー内に保存することで、再入力の手間を省いたり、お客様にとって最適なコンテンツを表示することができる機能です。当社では、インターネット広告の最適な表示、ユーザー数の把握、再入力の省略などのためにこの技術を利用しています。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "また、ご自身のブラウザをクッキーが送られてきた時に通知するように設定し、クッキーを受け取るかどうか選択することができます。ご自身のプラウザーのクッキー機能をオフに設定することも可能です。ただしこの場合、一部のサービスの機能が損なわれる場合がありますのでご注意ください。"
            ),
          ]),
          _c("h2", [
            _vm._v("13. 本人が容易に認識できない方法によるクッキー情報の取得"),
          ]),
          _c("p", [
            _vm._v(
              "当社では、ヤフー株式会社をはじめとする第三者から配信される広告が掲載される場合があり、これに関連して、当該第三者が、当社のサービスを訪問したお客様のクッキー情報等を取得し、利用している場合があります。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "当該第三者によって取得されたクッキー情報等は、当該第三者のプライバシーポリシーに従って取り扱われます。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "お客様は、当該第三者のウェブサイト内に設けられたオプトアウトページにアクセスして、当該第三者によるクッキー情報等の広告配信への利用を停止することができます。このサービスを無効にしたい場合は、各社のページにアクセスし、手順に従ってください。"
            ),
          ]),
          _c("ul", [
            _c("li", [
              _vm._v("グーグル株式会社"),
              _c("br"),
              _vm._v("以下のサイトからオプトアウトできます。"),
              _c("br"),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://www.google.co.jp/intl/ja/policies/privacy/ads/",
                  },
                },
                [
                  _vm._v(
                    "http://www.google.co.jp/intl/ja/policies/privacy/ads/"
                  ),
                ]
              ),
            ]),
            _c("li", [
              _vm._v("ヤフー株式会社"),
              _c("br"),
              _vm._v("以下のサイトからオプトアウトできます。"),
              _c("br"),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://btoptout.yahoo.co.jp/optout/index.html",
                  },
                },
                [_vm._v("http://btoptout.yahoo.co.jp/optout/index.html")]
              ),
            ]),
            _c("li", [
              _vm._v("フェイスブック株式会社"),
              _c("br"),
              _vm._v("以下のサイトからオプトアウトできます。"),
              _c("br"),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.facebook.com/ads/website_custom_audiences/",
                  },
                },
                [
                  _vm._v(
                    "https://www.facebook.com/ads/website_custom_audiences/"
                  ),
                ]
              ),
            ]),
          ]),
          _c("h2", [_vm._v("14. 広告について")]),
          _c("h3", [_vm._v("SSLについて")]),
          _c("p", [
            _vm._v(
              "当社のウェブサイトは、お客様の個人情報を保護するために必要に応じて「SSL」に対応しています。"
            ),
          ]),
          _c("p", [
            _vm._v(
              "Google Chrome、Safariといったセキュリティ機能に対応したブラウザを使用することで、お客様が入力される名前や住所あるいは電話番号などの個人情報が自動的に暗号化されて送受信されるため、万が一、送信データが第三者に傍受された場合でも、内容が盗み取られる心配はありません。SSLに対応していないブラウザをご利用の場合は、当社のWebサイトにアクセスできなかったり、情報の入力ができない場合があります。"
            ),
          ]),
          _c("h2", [_vm._v("15. 個人情報の管理")]),
          _c("p", [
            _vm._v(
              "当社はネットワークの不正アクセスに対して防護対策を行い当社管理サーバーに対し当社ネットワーク外からアクセスすることができないよう最大の努力をいたします。"
            ),
          ]),
          _c("h2", [_vm._v("16. 維持および技術の選定、対策")]),
          _c("p", [
            _vm._v(
              "当社はお客様の個人情報の安全性を確保すると共にその正確性を維持するために、特定の個人情報を送信する際には適切な対策と処置を講じております。"
            ),
          ]),
          _c("h2", [_vm._v("17. お客様の対応で発生するトラブル")]),
          _c("p", [
            _vm._v(
              "当社の個人情報はお客様のメールアドレスとパスワードによって保護されます。パスワードの管理責任はお客様ご本人にあります。お客様の不注意により利用しているメールアドレスやパスワードが流出したために発生した問題に関しましては当社は責任を一切負いません。"
            ),
          ]),
          _c("h2", [_vm._v("18. 第三者やお客様への対応")]),
          _c("p", [
            _vm._v(
              "当社は個人情報保護に対して最善をつくしますが、お客様の不注意やインターネット上でのトラブルで発生した問題に対して一切責任を負いません。"
            ),
          ]),
          _c("h2", [_vm._v("19. 個人情報に関するお問い合わせ先")]),
          _c("p", [
            _vm._v("個人情報に関するお問い合わせは、下記までお願いします。"),
          ]),
          _c("p", [
            _vm._v("〒102-0083"),
            _c("br"),
            _vm._v("東京都千代田区麹町麹町３丁目７−８ 山口ビル4階"),
            _c("br"),
            _vm._v("株式会社コノル"),
            _c("br"),
            _vm._v("個人情報保護責任者: 溝田 隆明"),
          ]),
        ]),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }